import React, { Component } from "react";
import { Button } from "./../../../common/Button/Button";
import moment from "moment";
import api from "../../../utils/api";

class StateAuditLogDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title,
      stateAuditLog: [],
    };
  }
  componentDidMount = () => {
    api.getStateAuditLogSPM(this.props.selectedService).then((d) => {
      this.setState({ stateAuditLog: d.data });
    });
  };

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (timeOut) => {
    this.setState({
      listOpen: false,
    });
  };

  toggleList() {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  }

  renderAuditTrail = () => {
    const { stateAuditLog = [] } = this.state;
    return stateAuditLog.map((audit, i) => {
      return (
        <div className="mt-2" key={i}>
          <div className="flex justify-content-between">
            <small>{audit.reqUser}</small>
            <small>{moment(audit.dtCreated).format("lll")}</small>
          </div>
          <div className="audit-body mt-2">
            <div>
              <small>State</small>
            </div>
            {audit.refCurrentState}
          </div>
        </div>
      );
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.listOpen !== nextState.listOpen) return true;
    if (this.props.stateAuditLog === nextProps.stateAuditLog) return false;
    return true;
  }

  render() {
    const { listOpen } = this.state;
    return (
      <div className="dd-wrapper alter-position  state-audit-log">
        <div
          className="dd-header alter-position"
          onClick={() => this.toggleList()}
        >
          <div className="dd-header-title">
            <Button>Status Log</Button>
          </div>
        </div>
        {listOpen && (
          <div className="dd-list state-audit-log-spm">
            <div>{this.renderAuditTrail()}</div>
          </div>
        )}
      </div>
    );
  }
}

export default StateAuditLogDropdown;
